// extracted by mini-css-extract-plugin
export default {"entry":"history_entry_row___entry___dfb295b3","badge":"history_entry_row___badge___b049ca6c"};